import React from "react";
import { HiOutlineSparkles } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneAttraction } from "../../../lib/sysNavigation/SysNavigation";

type AttractionRow = {
  attraction_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<AttractionRow>
    type={_TYPES_.ATTRACTION}
    title="Attractions"
    subtitle="Points of interest promoted on the public site."
    icon={<HiOutlineSparkles className="h-5 w-5" />}
    addRoute="/data/attraction/add"
    editRoute="/data/attraction/edit"
    pushOne={pushOneAttraction}
    dataKey="attractions"
    countKey="attractionsCount"
    idField="attraction_id"
    titleField="title"
  />
);

export default Overview;
